;(function () {
  if (!String.prototype.replaceAll) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(String.prototype, 'replaceAll', {
      configurable: true,
      writable: true,
      value: function replaceAll(search, replace) {
        if (search instanceof RegExp) {
          if (!search.global) {
            throw new TypeError(
              'String.prototype.replaceAll called with a non-global RegExp argument'
            )
          }
          return this.replace(search, replace)
        }
        return this.split(search).join(replace)
      },
    })
  }
})()
